import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../types/types";

interface BackupEntry {
    token: string | null;
    userId: string | null;
    returnTo?: string;
}

interface AuthState {
    isAuthenticated: boolean;
    token: string | null;
    userId: string | null;
    user: User | null;
    backupStack: BackupEntry[];
}

const initialState: AuthState = {
    isAuthenticated: false,
    token: null,
    userId: null,
    user: null,
    backupStack: [],
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials: (state, { payload }) => {
            state.isAuthenticated = true;
            state.token = payload.token;
            state.userId = payload.userId;
        },
        updateUser: (state, { payload }) => {
            state.user = payload;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.token = null;
            state.userId = null;
            state.user = null;
            state.backupStack = [];
        },
        backupRecruiter: (state, action: PayloadAction<{ returnTo?: string } | undefined>) => {
            state.backupStack.push({
                token: state.token,
                userId: state.userId,
                returnTo: action.payload?.returnTo,
            });
        },
        restoreRecruiter: (state) => {
            const backup = state.backupStack[state.backupStack.length - 1];
            if (backup) {
                state.token = backup.token;
                state.userId = backup.userId;
                state.backupStack = state.backupStack.slice(0, -1);
            }
        },
    },
});

export const { setCredentials, logout, updateUser, backupRecruiter, restoreRecruiter } = authSlice.actions;
export default authSlice.reducer;
